import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a0d767ce"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "navigation" }
const _hoisted_2 = { class: "navigation__menu" }
const _hoisted_3 = { class: "icon" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, " Dashboard ", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "separator" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "separator__title" }, "Content")
], -1))
const _hoisted_6 = { class: "icon" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, " Partners ", -1))
const _hoisted_8 = { class: "icon" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, " Deals ", -1))
const _hoisted_10 = { class: "icon" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, " Sites ", -1))
const _hoisted_12 = { class: "icon" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, " Casinos ", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "separator" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "separator__title" }, "Onboarding")
], -1))
const _hoisted_15 = { class: "icon" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, " Onboardings ", -1))
const _hoisted_17 = { class: "icon" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, " Offboardings ", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "separator" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "separator__title" }, "Analytics")
], -1))
const _hoisted_20 = { class: "icon" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, " Tokens ", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "separator" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "separator__title" }, "Other")
], -1))
const _hoisted_23 = { class: "icon" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, " Notifications ", -1))
const _hoisted_25 = { class: "icon" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, " Dashboard ", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "separator" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "separator__title" }, "Content")
], -1))
const _hoisted_28 = { class: "icon" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, " Partners ", -1))
const _hoisted_30 = { class: "icon" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, " Deals ", -1))
const _hoisted_32 = { class: "icon" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, " Sites ", -1))
const _hoisted_34 = { class: "icon" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, " Casinos ", -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "separator" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "separator__title" }, "Onboarding")
], -1))
const _hoisted_37 = { class: "icon" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, " Onboardings ", -1))
const _hoisted_39 = { class: "icon" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, " Offboardings ", -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "separator" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "separator__title" }, "Analytics")
], -1))
const _hoisted_42 = { class: "icon" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, " Tokens ", -1))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "separator" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "separator__title" }, "Other")
], -1))
const _hoisted_45 = { class: "icon" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "Settings", -1))
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, " Users ", -1))
const _hoisted_48 = { class: "icon" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, " Notifications ", -1))
const _hoisted_50 = { class: "icon" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, " Scrapers ", -1))
const _hoisted_52 = { class: "icon" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, " Dashboard ", -1))
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "separator" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "separator__title" }, "Content")
], -1))
const _hoisted_55 = { class: "icon" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, " Partners ", -1))
const _hoisted_57 = { class: "icon" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, " Deals ", -1))
const _hoisted_59 = { class: "icon" }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, " Sites ", -1))
const _hoisted_61 = { class: "icon" }
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, " Casinos ", -1))
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "separator" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "separator__title" }, "Onboarding")
], -1))
const _hoisted_64 = { class: "icon" }
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, " Onboardings ", -1))
const _hoisted_66 = { class: "icon" }
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, " Offboardings ", -1))
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "separator" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "separator__title" }, "Analytics")
], -1))
const _hoisted_69 = { class: "icon" }
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, " Tokens ", -1))
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "separator" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "separator__title" }, "Other")
], -1))
const _hoisted_72 = { class: "icon" }
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "Settings", -1))
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, " Users ", -1))
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, " Webhooks ", -1))
const _hoisted_76 = { class: "icon" }
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, " Notifications ", -1))
const _hoisted_78 = { class: "icon" }
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, " Scrapers ", -1))
const _hoisted_80 = { class: "icon" }
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, " Send Slack Notification ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_House = _resolveComponent("House")!
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_Coin = _resolveComponent("Coin")!
  const _component_Connection = _resolveComponent("Connection")!
  const _component_Monitor = _resolveComponent("Monitor")!
  const _component_Money = _resolveComponent("Money")!
  const _component_MessageBox = _resolveComponent("MessageBox")!
  const _component_Key = _resolveComponent("Key")!
  const _component_Notification = _resolveComponent("Notification")!
  const _component_el_menu = _resolveComponent("el-menu")!
  const _component_Setting = _resolveComponent("Setting")!
  const _component_el_sub_menu = _resolveComponent("el-sub-menu")!
  const _component_DataBoard = _resolveComponent("DataBoard")!
  const _component_Bell = _resolveComponent("Bell")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.isUserRoleAbilityAdministrator)
        ? (_openBlock(), _createBlock(_component_el_menu, {
            key: 0,
            onSelect: _ctx.setRoute
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_menu_item, { index: "AdministrationAdministratorDashboardIndex" }, {
                title: _withCtx(() => [
                  _createElementVNode("span", _hoisted_3, [
                    _createVNode(_component_House)
                  ]),
                  _hoisted_4
                ]),
                _: 1
              }),
              _hoisted_5,
              _createVNode(_component_el_menu_item, { index: "AdministrationAdministratorPartnersIndex" }, {
                title: _withCtx(() => [
                  _createElementVNode("span", _hoisted_6, [
                    _createVNode(_component_Coin)
                  ]),
                  _hoisted_7
                ]),
                _: 1
              }),
              _createVNode(_component_el_menu_item, { index: "AdministrationAdministratorDealsIndex" }, {
                title: _withCtx(() => [
                  _createElementVNode("span", _hoisted_8, [
                    _createVNode(_component_Connection)
                  ]),
                  _hoisted_9
                ]),
                _: 1
              }),
              _createVNode(_component_el_menu_item, { index: "AdministrationAdministratorSitesIndex" }, {
                title: _withCtx(() => [
                  _createElementVNode("span", _hoisted_10, [
                    _createVNode(_component_Monitor)
                  ]),
                  _hoisted_11
                ]),
                _: 1
              }),
              _createVNode(_component_el_menu_item, { index: "AdministrationAdministratorCasinosIndex" }, {
                title: _withCtx(() => [
                  _createElementVNode("span", _hoisted_12, [
                    _createVNode(_component_Money)
                  ]),
                  _hoisted_13
                ]),
                _: 1
              }),
              _hoisted_14,
              _createVNode(_component_el_menu_item, { index: "AdministrationAdministratorOnboardingsIndex" }, {
                title: _withCtx(() => [
                  _createElementVNode("span", _hoisted_15, [
                    _createVNode(_component_MessageBox)
                  ]),
                  _hoisted_16
                ]),
                _: 1
              }),
              _createVNode(_component_el_menu_item, { index: "AdministrationAdministratorOffboardingsIndex" }, {
                title: _withCtx(() => [
                  _createElementVNode("span", _hoisted_17, [
                    _createVNode(_component_MessageBox)
                  ]),
                  _hoisted_18
                ]),
                _: 1
              }),
              _hoisted_19,
              _createVNode(_component_el_menu_item, { index: "AdministrationAdministratorTokensIndex" }, {
                title: _withCtx(() => [
                  _createElementVNode("span", _hoisted_20, [
                    _createVNode(_component_Key)
                  ]),
                  _hoisted_21
                ]),
                _: 1
              }),
              _hoisted_22,
              _createVNode(_component_el_menu_item, { index: "AdministrationAdministratorNotificationsIndex" }, {
                title: _withCtx(() => [
                  _createElementVNode("span", _hoisted_23, [
                    _createVNode(_component_Notification)
                  ]),
                  _hoisted_24
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["onSelect"]))
        : _createCommentVNode("", true),
      (_ctx.isUserRoleAbilityOwner)
        ? (_openBlock(), _createBlock(_component_el_menu, {
            key: 1,
            onSelect: _ctx.setRoute
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_menu_item, { index: "AdministrationOwnerDashboardIndex" }, {
                title: _withCtx(() => [
                  _createElementVNode("span", _hoisted_25, [
                    _createVNode(_component_House)
                  ]),
                  _hoisted_26
                ]),
                _: 1
              }),
              _hoisted_27,
              _createVNode(_component_el_menu_item, { index: "AdministrationOwnerPartnersIndex" }, {
                title: _withCtx(() => [
                  _createElementVNode("span", _hoisted_28, [
                    _createVNode(_component_Coin)
                  ]),
                  _hoisted_29
                ]),
                _: 1
              }),
              _createVNode(_component_el_menu_item, { index: "AdministrationOwnerDealsIndex" }, {
                title: _withCtx(() => [
                  _createElementVNode("span", _hoisted_30, [
                    _createVNode(_component_Connection)
                  ]),
                  _hoisted_31
                ]),
                _: 1
              }),
              _createVNode(_component_el_menu_item, { index: "AdministrationOwnerSitesIndex" }, {
                title: _withCtx(() => [
                  _createElementVNode("span", _hoisted_32, [
                    _createVNode(_component_Monitor)
                  ]),
                  _hoisted_33
                ]),
                _: 1
              }),
              _createVNode(_component_el_menu_item, { index: "AdministrationOwnerCasinosIndex" }, {
                title: _withCtx(() => [
                  _createElementVNode("span", _hoisted_34, [
                    _createVNode(_component_Money)
                  ]),
                  _hoisted_35
                ]),
                _: 1
              }),
              _hoisted_36,
              _createVNode(_component_el_menu_item, { index: "AdministrationOwnerOnboardingsIndex" }, {
                title: _withCtx(() => [
                  _createElementVNode("span", _hoisted_37, [
                    _createVNode(_component_MessageBox)
                  ]),
                  _hoisted_38
                ]),
                _: 1
              }),
              _createVNode(_component_el_menu_item, { index: "AdministrationOwnerOffboardingsIndex" }, {
                title: _withCtx(() => [
                  _createElementVNode("span", _hoisted_39, [
                    _createVNode(_component_MessageBox)
                  ]),
                  _hoisted_40
                ]),
                _: 1
              }),
              _hoisted_41,
              _createVNode(_component_el_menu_item, { index: "AdministrationOwnerTokensIndex" }, {
                title: _withCtx(() => [
                  _createElementVNode("span", _hoisted_42, [
                    _createVNode(_component_Key)
                  ]),
                  _hoisted_43
                ]),
                _: 1
              }),
              _hoisted_44,
              _createVNode(_component_el_sub_menu, { index: "AdministrationOwnerSettingsIndex" }, {
                title: _withCtx(() => [
                  _createElementVNode("span", _hoisted_45, [
                    _createVNode(_component_Setting)
                  ]),
                  _hoisted_46
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_el_menu_item, { index: "AdministrationOwnerUsersIndex" }, {
                    title: _withCtx(() => [
                      _hoisted_47
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_menu_item, { index: "AdministrationOwnerNotificationsIndex" }, {
                title: _withCtx(() => [
                  _createElementVNode("span", _hoisted_48, [
                    _createVNode(_component_Notification)
                  ]),
                  _hoisted_49
                ]),
                _: 1
              }),
              _createVNode(_component_el_menu_item, { index: "AdministrationOwnerScrapersIndex" }, {
                title: _withCtx(() => [
                  _createElementVNode("span", _hoisted_50, [
                    _createVNode(_component_DataBoard)
                  ]),
                  _hoisted_51
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["onSelect"]))
        : _createCommentVNode("", true),
      (_ctx.isUserRoleAbilitySuperAdministrator)
        ? (_openBlock(), _createBlock(_component_el_menu, {
            key: 2,
            onSelect: _ctx.setRoute
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_menu_item, { index: "AdministrationSuperAdministratorDashboardIndex" }, {
                title: _withCtx(() => [
                  _createElementVNode("span", _hoisted_52, [
                    _createVNode(_component_House)
                  ]),
                  _hoisted_53
                ]),
                _: 1
              }),
              _hoisted_54,
              _createVNode(_component_el_menu_item, { index: "AdministrationSuperAdministratorPartnersIndex" }, {
                title: _withCtx(() => [
                  _createElementVNode("span", _hoisted_55, [
                    _createVNode(_component_Coin)
                  ]),
                  _hoisted_56
                ]),
                _: 1
              }),
              _createVNode(_component_el_menu_item, { index: "AdministrationSuperAdministratorDealsIndex" }, {
                title: _withCtx(() => [
                  _createElementVNode("span", _hoisted_57, [
                    _createVNode(_component_Connection)
                  ]),
                  _hoisted_58
                ]),
                _: 1
              }),
              _createVNode(_component_el_menu_item, { index: "AdministrationSuperAdministratorSitesIndex" }, {
                title: _withCtx(() => [
                  _createElementVNode("span", _hoisted_59, [
                    _createVNode(_component_Monitor)
                  ]),
                  _hoisted_60
                ]),
                _: 1
              }),
              _createVNode(_component_el_menu_item, { index: "AdministrationSuperAdministratorCasinosIndex" }, {
                title: _withCtx(() => [
                  _createElementVNode("span", _hoisted_61, [
                    _createVNode(_component_Money)
                  ]),
                  _hoisted_62
                ]),
                _: 1
              }),
              _hoisted_63,
              _createVNode(_component_el_menu_item, { index: "AdministrationSuperAdministratorOnboardingsIndex" }, {
                title: _withCtx(() => [
                  _createElementVNode("span", _hoisted_64, [
                    _createVNode(_component_MessageBox)
                  ]),
                  _hoisted_65
                ]),
                _: 1
              }),
              _createVNode(_component_el_menu_item, { index: "AdministrationSuperAdministratorOffboardingsIndex" }, {
                title: _withCtx(() => [
                  _createElementVNode("span", _hoisted_66, [
                    _createVNode(_component_MessageBox)
                  ]),
                  _hoisted_67
                ]),
                _: 1
              }),
              _hoisted_68,
              _createVNode(_component_el_menu_item, { index: "AdministrationSuperAdministratorTokensIndex" }, {
                title: _withCtx(() => [
                  _createElementVNode("span", _hoisted_69, [
                    _createVNode(_component_Key)
                  ]),
                  _hoisted_70
                ]),
                _: 1
              }),
              _hoisted_71,
              _createVNode(_component_el_sub_menu, { index: "AdministrationSuperAdministratorSettingsIndex" }, {
                title: _withCtx(() => [
                  _createElementVNode("span", _hoisted_72, [
                    _createVNode(_component_Setting)
                  ]),
                  _hoisted_73
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_el_menu_item, { index: "AdministrationSuperAdministratorUsersIndex" }, {
                    title: _withCtx(() => [
                      _hoisted_74
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_menu_item, { index: "AdministrationSuperAdministratorWebhooksIndex" }, {
                    title: _withCtx(() => [
                      _hoisted_75
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_menu_item, { index: "AdministrationSuperAdministratorNotificationsIndex" }, {
                title: _withCtx(() => [
                  _createElementVNode("span", _hoisted_76, [
                    _createVNode(_component_Notification)
                  ]),
                  _hoisted_77
                ]),
                _: 1
              }),
              _createVNode(_component_el_menu_item, { index: "AdministrationSuperAdministratorScrapersIndex" }, {
                title: _withCtx(() => [
                  _createElementVNode("span", _hoisted_78, [
                    _createVNode(_component_DataBoard)
                  ]),
                  _hoisted_79
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["onSelect"]))
        : _createCommentVNode("", true),
      _createVNode(_component_el_menu, { onSelect: _ctx.setDialog }, {
        default: _withCtx(() => [
          _createVNode(_component_el_menu_item, { index: "ProfileIndex" }, {
            title: _withCtx(() => [
              _createElementVNode("span", _hoisted_80, [
                _createVNode(_component_Bell)
              ]),
              _hoisted_81
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["onSelect"])
    ]),
    _createVNode(_component_el_dialog, {
      title: "Send Slack Notification",
      modelValue: _ctx.isDialogVisible,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.isDialogVisible) = $event)),
      class: "el-dialog--is-scrollable"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: _ctx.formData,
          rules: _ctx.formDataRules,
          ref: "formComponent",
          onSubmit: _withModifiers(_ctx.validateForm, ["prevent"])
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "Title",
              prop: "title"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.formData.title,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.title) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "Message",
              prop: "message"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.formData.message,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.message) = $event)),
                  type: "textarea"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "Webhooks",
              prop: "webhooks"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _ctx.formData.webhooks,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.webhooks) = $event)),
                  placeholder: "Choose",
                  filterable: "",
                  clearable: "",
                  multiple: ""
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.webhooks, (webhook) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        label: webhook.name,
                        value: webhook.id,
                        key: webhook.id
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  type: "primary",
                  class: "el-button--is-primary el-button--is-block",
                  "native-type": "submit",
                  loading: _ctx.isLoading
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Send")
                  ]),
                  _: 1
                }, 8, ["loading"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules", "onSubmit"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}